<template>
  <div class="analysis-conclusion-card" :class="conclusionStatus">
    <div class="ac-header">
      <div class="ac-icon">
        <svg v-if="status === 'success'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <svg v-else-if="status === 'warning'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14">
          <line x1="12" y1="8" x2="12" y2="13"></line>
          <line x1="12" y1="16" x2="12" y2="16"></line>
        </svg>
        <svg v-else-if="status === 'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14">
          <line x1="12" y1="8" x2="12" y2="13"></line>
          <line x1="12" y1="16" x2="12" y2="16"></line>
        </svg>
      </div>
      <div class="ac-title">{{ title }}</div>
    </div>
    <div class="ac-points" v-if="parsedPoints.length > 0">
      <div v-for="(point, idx) in parsedPoints" :key="idx" class="ac-point">{{ point }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalysisConclusion',
  props: {
    title: { type: String, default: '' },
    status: { type: String, default: 'success' },
    points: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedPoints() {
      if (Array.isArray(this.points)) return this.points
      if (typeof this.points === 'string') {
        try {
          const parsed = JSON.parse(this.points)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    },
    conclusionStatus() {
      return `status-${this.status}`
    }
  }
}
</script>

<style lang="scss" scoped>
.analysis-conclusion-card {
  max-width: 800px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #4A5FF3;
  border-radius: 8px;
}

.ac-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}

.ac-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  color: #fff;
}

.status-success .ac-icon {
  background: #22c55e;
}

.status-warning .ac-icon {
  background: #f59e0b;
}

.status-error .ac-icon {
  background: #ef4444;
}

.status-info .ac-icon {
  background: #3b82f6;
}

.ac-title {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.6;
}

.ac-points {
  padding-left: 34px;
}

.ac-point {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.7;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
